import React, { useState, useEffect } from "react";
import { Modal } from "rsuite";
import { Button, DataInput } from "../../../components";
import ToastService from "../../../services/toast.service";
import logger from "../../../utils/logger";

function CreateChildMatchModal({ open, onClose, onSave, service, centreId }) {  const [formData, setFormData] = useState({
    childId: "",
    winzChildName: "",
    winzSwnNumber: "",
    centreId: centreId || ""
  });
  const [loading, setLoading] = useState(false);

  // Update centreId when prop changes
  useEffect(() => {
    setFormData(prev => ({
      ...prev,
      centreId: centreId || ""
    }));
  }, [centreId]);

  // Function to format SWN number with dashes, max 9 digits
  const formatSwnNumber = (value) => {
    // Remove all non-numeric characters and limit to 9 digits
    const numbers = value.replace(/\D/g, '').slice(0, 9);
    // Add dashes after every 3 digits
    let formatted = '';
    for (let i = 0; i < numbers.length; i++) {
      if (i > 0 && i % 3 === 0) {
        formatted += '-';
      }
      formatted += numbers[i];
    }
    return formatted;
  };

  const handleInputChange = (field, value) => {
    if (field === 'winzSwnNumber') {
      value = formatSwnNumber(value);
    }
    if (field === 'childId') {
      // Only allow numbers for childId
      value = value.replace(/\D/g, '');
    }
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSubmit = async () => {
    try {
      // Validate required fields
      if (!formData.childId || !formData.winzChildName || !formData.winzSwnNumber || !formData.centreId) {
        ToastService.error("Please fill in all required fields");
        return;
      }

      setLoading(true);

      if (!service) {
        throw new Error("Service instance not provided");
      }

      // Create the child match
      await service.createChildMatch(formData);
      
      ToastService.success("Child match created successfully");
      
      // Call the parent onSave callback
      if (onSave) {
        onSave(formData);
      }
        // Reset form and close modal
      setFormData({
        childId: "",
        winzChildName: "",
        winzSwnNumber: "",
        centreId: centreId || ""
      });
      onClose();
      
    } catch (error) {
      logger.error("Error creating child match:", error);
      ToastService.error(`Failed to create child match: ${error.message || "Unknown error"}`);
    } finally {
      setLoading(false);
    }
  };
  const handleCancel = () => {
    // Reset form data
    setFormData({
      childId: "",
      winzChildName: "",
      winzSwnNumber: "",
      centreId: centreId || ""
    });
    onClose();
  };

  return (
    <Modal open={open} onClose={handleCancel} size="md">
      <Modal.Header>
        <Modal.Title>Create Child Match</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="create-child-container" >
          <DataInput
            label="Child ID"
            placeholder="Enter Child ID"
            value={formData.childId}
            onChange={(e) => handleInputChange("childId", e.target.value)}
          />
          <DataInput
            label="WINZ Child Name"
            placeholder="Enter WINZ Child Name"
            value={formData.winzChildName}
            onChange={(e) => handleInputChange("winzChildName", e.target.value)}
          />
            <DataInput
            label="WINZ SWN Number"
            placeholder="000-000-000"
            value={formData.winzSwnNumber}
            onChange={(e) => handleInputChange("winzSwnNumber", e.target.value)}
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          onClick={handleSubmit}
          loading={loading}
          disabled={loading}
          text="Create"
        />
        <Button
          onClick={handleCancel}
          disabled={loading}
          text="Cancel"
          color="blue"
         />
      </Modal.Footer>
    </Modal>
  );
}

export default CreateChildMatchModal;
